import React from "react";
import { motion } from "framer-motion";

const previewCards = [
  {
    tag: "Public · Telegram",
    title: "EUR/USD OTC · UP",
    arrow: "▲",
    time: "14:02 UTC",
    rows: [
      { k: "Asset", v: "EUR/USD OTC" },
      { k: "Direction", v: "UP" },
      { k: "Duration", v: "M1" },
      { k: "Payout", v: "92%" },
      { k: "Confidence", v: "95%" },
    ],
    state: "WON",
  },
  {
    tag: "Public · Telegram",
    title: "GBP/JPY OTC · DOWN",
    arrow: "▼",
    time: "13:18 UTC",
    rows: [
      { k: "Asset", v: "GBP/JPY OTC" },
      { k: "Direction", v: "DOWN" },
      { k: "Duration", v: "M5" },
      { k: "Payout", v: "88%" },
      { k: "Confidence", v: "88%" },
    ],
    state: "WON",
  },
  {
    tag: "Public · Telegram",
    title: "USD/CHF OTC · UP",
    arrow: "▲",
    time: "12:44 UTC",
    rows: [
      { k: "Asset", v: "USD/CHF OTC" },
      { k: "Direction", v: "UP" },
      { k: "Duration", v: "M1" },
      { k: "Payout", v: "90%" },
      { k: "Confidence", v: "92%" },
    ],
    state: "WON",
  },
];

const SignalCard = ({ c, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: [0.2, 0.7, 0.2, 1], delay: i * 0.08 }}
    whileHover={{ y: -6 }}
    className="group relative overflow-hidden rounded-[24px] glass-panel p-7"
    data-testid={`signal-card-${i}`}
  >
    <div className="absolute -top-20 -right-20 h-44 w-44 rounded-full bg-[rgba(78,168,255,0.10)] blur-2xl opacity-70 group-hover:opacity-100 transition-opacity duration-700" />

    <div className="relative flex items-center justify-between">
      <span className="text-[10px] tracking-[0.3em] uppercase text-white/40">{c.tag}</span>
      <span className="font-mono-luxe text-[10.5px] text-white/40">{c.time}</span>
    </div>

    <h3 className="relative mt-5 font-display text-[24px] md:text-[28px] text-white tracking-tight flex items-center gap-2">
      <span className={`${c.arrow === "▲" ? "text-[#4ea8ff]" : "text-white/70"} text-[18px]`}>{c.arrow}</span>
      {c.title}
    </h3>

    <div className="relative mt-6 flex flex-col divide-y divide-white/[0.05]">
      {c.rows.map((r) => (
        <div key={r.k} className="flex items-center justify-between py-3">
          <span className="text-[11.5px] tracking-[0.2em] uppercase text-white/40">{r.k}</span>
          <span className="font-mono-luxe text-[14px] text-white/85">{r.v}</span>
        </div>
      ))}
    </div>

    <div className="relative mt-5 flex items-center justify-between">
      <span className="inline-flex items-center gap-2 rounded-full border border-[#4ea8ff]/30 bg-[#4ea8ff]/[0.06] px-3 py-1 text-[10px] tracking-[0.3em] uppercase text-[#cfe6ff]">
        <span className="h-1.5 w-1.5 rounded-full bg-[#4ea8ff] shadow-[0_0_8px_#4ea8ff]" />
        Closed · {c.state}
      </span>
      <span className="text-[11px] text-white/40">Channel preview</span>
    </div>
  </motion.div>
);

const PublicSignals = () => {
  return (
    <section id="signals" className="relative py-28 md:py-36">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center text-center max-w-[760px] mx-auto"
        >
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.32em] uppercase text-white/40">
            <span className="h-px w-8 bg-white/20" /> Public Signals
          </span>
          <h2 className="mt-6 font-display text-[40px] sm:text-[52px] md:text-[64px] leading-[1.02] tracking-[-0.03em] text-balance">
            <span className="text-gradient-silver">Experience BIGBULL</span>{" "}
            <span className="text-gradient-blue">before VIP access.</span>
          </h2>
          <p className="mt-6 text-[15px] md:text-[16px] text-white/55 font-light max-w-[560px]">
            A taste of the precision. Public Quotex binary signals on Telegram — same engine, lighter cadence.
          </p>
        </motion.div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {previewCards.map((c, i) => (
            <SignalCard c={c} i={i} key={c.title} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PublicSignals;
